import { queryOptions } from '@tanstack/react-query';
import { payment_links as paymentLinks } from '#proto/index.qonto.cards_acceptance';
import { client, type QueryValue } from '#queries/utils';
import { ApiSearchPaymentsRequest } from '#proto/qonto/cards_acceptance/payment_links/payments/firstparty/v5/search_payments';

const { ApiGetConnectionResponse } = paymentLinks.connections.firstparty.v2;
const { ApiGetMethodsResponse } = paymentLinks.methods.firstparty.v1;
const { ApiSearchPaymentsResponse, ApiGetPaymentByIdResponse } =
  paymentLinks.payments.firstparty.v5;

function connection({ organizationId }: { organizationId: string }) {
  return queryOptions({
    queryKey: [...paymentLinksQueries.connections(), organizationId] as const,
    queryFn: async () => {
      const data = await client('/v1/mollie/connections');

      return ApiGetConnectionResponse.fromJSON(data);
    },
  });
}

function methodList() {
  return queryOptions({
    queryKey: paymentLinksQueries.methodLists(),
    queryFn: async () => {
      const data = await client('/payment_links/v1/methods');

      return ApiGetMethodsResponse.fromJSON(data);
    },
  });
}

function paymentSearch(params: ApiSearchPaymentsRequest) {
  return queryOptions({
    queryKey: [...paymentLinksQueries.paymentSearches(), params],
    queryFn: async () => {
      const data = await client('/payment_links/v5/payments/search', {
        params: ApiSearchPaymentsRequest.toJSON(params) as Record<string, QueryValue>,
      });

      return ApiSearchPaymentsResponse.fromJSON(data);
    },
  });
}

function paymentGet(id: string) {
  return queryOptions({
    queryKey: [...paymentLinksQueries.paymentGets(), id],
    queryFn: async () => {
      const data = await client(`/payment_links/v5/payments/${id}`);

      return ApiGetPaymentByIdResponse.fromJSON(data);
    },
  });
}

export const paymentLinksQueries = {
  all: 'payment-links-connection' as const,
  connections: () => [paymentLinksQueries.all, 'connection'] as const,
  connection,
  methodLists: () => [paymentLinksQueries.all, 'method-list'] as const,
  methodList,
  paymentSearches: () => [paymentLinksQueries.all, 'payment-search'] as const,
  paymentSearch,
  paymentGets: () => [paymentLinksQueries.all, 'payment-get'] as const,
  paymentGet,
};
